import { QUERY_KEY } from 'constants/globalConstants'
import UserService from 'apiService/permissions'
import { useQuery } from 'react-query'

const useGetRoles = (pageSize, currentPage) => {
    return useQuery(QUERY_KEY.GET_ROLES, () => UserService.getRoles(pageSize, currentPage), {retry: false})
}

export default useGetRoles